/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, May 2020
 */
export { URL } from './URL';
export { URLSearch } from './URLSearch';



// WEBPACK FOOTER //
// ./src/packages/http/lib/URL/index.ts